import type { HTMLAttributes } from "react";
import { tv, type VariantProps } from "tailwind-variants";

const cardStyles = tv({
  base: "rounded-xl border border-border bg-overlay text-overlay-fg shadow-sm",
});

export type CardVariants = VariantProps<typeof cardStyles>;

export interface CardProps extends HTMLAttributes<HTMLDivElement>, CardVariants {}

/** A surface container that visually separates content from the page background. */
export function Card({ className, ...props }: CardProps) {
  return <div className={cardStyles({ className })} {...props} />;
}

/** Optional header section inside a Card. */
export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`px-6 pt-6 pb-2 ${className ?? ""}`} {...props} />;
}

/** Main content area inside a Card. */
export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`px-6 py-4 ${className ?? ""}`} {...props} />;
}

/** Optional footer section inside a Card. */
export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`px-6 pt-2 pb-6 ${className ?? ""}`} {...props} />;
}
